<template>
    <div class="ReLeadTable"
		v-loading.fullscreen.lock="$GVO.fullscreenLoading"
		element-loading-text="Загрузка данных..."
		element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)"	
		>
		<card>

		<div class="btn-sticky align-items-center" v-if="this.$GVO.my_profile.adm == 1 || this.$GVO.my_profile.OperatorCC == 1">
			<base-button @click="StartChange()" type="success" class="mb-3 mr-2" simple>Выбрать и сохранить объекты</base-button>
			<base-button type="primary" class="mb-3 mr-2 " simple @click="clearObjects">Очистить выборку</base-button>

		</div>

		<div v-if="masSend && masSend.length>0" class="ml-1 mt-2">
			<h6>Выбранные объекты: </h6>
			<ul class="list-unstyled result-marker" v-if="masSend && masSend.length>0">
				<li v-for="(obj,index) in masSend" :key="index">
					<span v-if="obj.promo" class="badge badge-pill badge-primary mr-2">промо</span>
					<span><b>id</b>: {{ obj.id }}, </span>
					<span><b>цена:</b> {{ obj.price }} ₽, </span>
					<span><b>площадь:</b> {{ obj.square }} м2, </span>
					<span v-if="obj.roomsCountTotal && obj.roomsCountTotal!=''"><b >количество комнат:</b> {{ obj.roomsCountTotal }}, </span>
					<span v-if="obj.landSquare && obj.landSquare!=''"><b >площадь участка:</b> {{ obj.landSquare }} м2, </span>
					<span><b>ответственный за услугу:</b> {{ obj.service_agent_fio }}, </span>
					<span><b>тип сделки:</b> {{ obj.dealType }}, </span>
					<span><b>тип объекта:</b> {{ obj.objectType }}, </span>
					<span v-if="obj.address && obj.address!=''"><b>адрес:</b> {{ obj.address }}</span>
					<span v-if="obj.MapAddress && obj.MapAddress.address.inputText!=''"><b>адрес:</b> {{ obj.MapAddress.address.inputText }}</span>
					<button :key="obj.id" class="ml-3 btn btn-icon btn-simple btn-danger" @click="delSelectedObject(index, obj.id)">
						<i class="tim-icons icon-trash-simple"></i>
					</button>
				</li> 
			</ul> 
		</div>


		<el-table 
		ref="multipleTable"
		:data="objData" 
		style="width: 100%"
		@selection-change="handleSelectionChange"
		:row-key="row => row.id"
		>	
			<el-table-column
				v-if="this.$GVO.my_profile.adm == 1 || this.$GVO.my_profile.OperatorCC == 1"
				:reserve-selection="true"
				:id="objData.id"
				type="selection"
				width="55">
			</el-table-column>
			<el-table-column
			label="id"
			min-width="120"
			prop="id">
				<template v-slot="scope">
					<!-- <a :href="'/data/module/mo/object/'+scope.row.id">Объект ID {{scope.row.id}}</a> -->

					<router-link tag="a" :to="`/data/module/mo/object/${scope.row.id}`">
						Объект ID {{scope.row.id}} <span v-if="scope.row.promo" class="badge badge-pill badge-primary mr-2">промо</span> 
					</router-link>	
				</template>
			</el-table-column>

			<el-table-column
			label="Реклама"
			min-width="100"
			prop="export_sites_count">
				<template v-slot="scope">
					<p v-if="scope.row._actual>0">Актуально</p>
					<p v-else class="text-danger">Снято</p>
				</template>
			</el-table-column>

			<el-table-column
			label="Тип объекта"
			min-width="100"
			prop="objectType">
			</el-table-column>
			
			<!-- <el-table-column
			label="Комнат"
			min-width="70"
			prop="roomsCountTotal">
			</el-table-column> -->
			
			<el-table-column
			label="Комнат"
			min-width="70"
			prop="roomsCountTotal">
				<template v-slot="scope">
					<template v-if="scope.row.objectType=='Комната'">
						{{ scope.row.roomsCount }} из {{ scope.row.roomsCountTotal }} 
					</template>
					<template v-else>
						{{ scope.row.roomsCountTotal }} 
					</template>
					
				</template>
			</el-table-column>

			<el-table-column
				label="Адрес"
				min-width="420"
				prop="MapAddress"
			>
				<template v-slot="scope">
					<template v-if="scope.row.MapAddress.address.inputText && scope.row.MapAddress.address.inputText!=''">
						{{ scope.row.MapAddress.address.inputText }} 
					</template>
					<template v-if="scope.row.address && scope.row.address!=''">
						{{ scope.row.address }} 
					</template>
				</template>
			</el-table-column>
			<el-table-column
				label="Ответственный"
				min-width="200"
				prop="service_agent_id"
			>
				<template v-slot="scope">
					{{scope.row.agent_fio}}
				</template>
				
			</el-table-column>

			<el-table-column
				label="S общая, м2"
				min-width="120"
				prop="square">
			</el-table-column>


			<el-table-column
				width="140"
				sortable
				:sort-method="sortPrice"
				label="ЦЕНА"
				prop="price"
				>
				<template v-slot="scope">
					<div>{{$GVO.number_format(scope.row.price,0,'.',' ')}} ₽</div>
				</template>
			</el-table-column>

		</el-table>
	</card>
    </div>
</template>
<script>

// import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
// import { BaseRadio } from 'src/components/index';
// import Pagination from 'src/our_components/RePagination';
// import ReInputSearchDrop from "src/our_components/ReInputSearchDrop.vue";
import messageTransport from "src/mixins/messageTransport.js";
// import Vue from 'vue';

export default {
	name: 'ReLeadTableCopy',
	mixins:[
		messageTransport,
	],
	components: {
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Option.name]: Option,
		[Select.name]: Select,
		[Tooltip.name]: Tooltip,
		[Button.name]: Button,
		// Pagination,
		// BaseRadio,
		// ReInputSearchDrop,
	},
	
	props: {
		objData: [Object, Array],
		// masObjects_total: [String, Number],
		objId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
			type: [String, Number],
			default: '',
		},
		objects: Array,
	},
	watch:{
		objects:{
			deep:true,
			handler(val){
				this.objects  = val ;
				// this.handleSelectionChange(this.objects);
				// this.cashedTableSelection = val;

				// console.log(sessionStorage);

				// if(this.cashedTableSelection.length > 0){
				// 	this.checkTableRows(this.masSend);
				// }
				
			}
		},
		
		// objects:{
		// 		deep:true,
		// 		handler(val){
		// 			this.objects  = val ;
		// 			this.handleSelectionChange(this.objects);
		// 		}
		// 	},
		
	},
	computed: {
		storageName(){
			return 'lead-search-objects';
		},
		
	},
	data() {
		return {
			masSend:[],
			cashedTableSelection: [],
			sessionStorageData: '',
			finalBossSend:[],
			
		};
	},
	created(){
		// console.log('something was created');
		// window.onpopstate = function(event) {
		// 	console.log("location: " + document.location + ", state: " + JSON.stringify(event.state));
		// };
	},
	methods: {
		sortPrice(a,b){
			return parseInt(a.price) - parseInt(b.price);
		},	
		onAgentChange(evt,row){
			//console.log(evt,row);
			row.service_agent_id = evt.selectedVal;
			row.service_agent_fio = evt.inputText;
		},
		StartChange(){
			// this.finalBossSend = [];
			if(this.masSend.length>0){
				let temSend = [];
				
				for (let i = 0; i < this.masSend.length; i++) {
					temSend.push(this.masSend[i]);
				}
				for(let j = 0; j < this.objects.length; j++){
					//это для сохранения прошлой выборки, если что-то пошло не так и нужно отредактировать лид 
					temSend.push(this.objects[j]);
				}

				this.finalBossSend = [
					...new Map(temSend.map((item) => [item['id'], item])).values(),
					// вроде эту штуку я делала, чтобы получить уникальные объекты, если выберут дважды одно и тоже -- это было овзможным, когда чекбоксы сбраывались при переходе по пагинации
					// но если навесить на колонку типа Селект :reserve-selection="true" и на таблицу :row-key, тогда пагинация не сбрасывает выбранные на разных стр-цах чекбоксы
					
				];
				
				// ниже было нужно для iframe data
				// let uniqueObjects = [
				// 	...new Map(this.masSend.map((item) => [item['id'], item])).values(),
				// ];
				// let data = uniqueObjects;
				// this.$emit("LeadObjects", this.masSend);
				
				this.message2parent('LeadObjects', this.finalBossSend);
				// console.log('StartChange finalBossSend ', this.finalBossSend);
			}
			//Если из родительского компонента удалить уже сохраненный объект, то тут галочка все равно останется, кого-то может запутать, посему пока обнулить выборку, пока не придумаю как обновить и тут
			this.masSend = [];
			this.finalBossSend = [];
			this.checkTableRows();
			sessionStorage.removeItem('lead-objects-open');
		},

		handleSelectionChange(val) {
			this.masSend = val; 
			this.saveLocalSettings(); // при каждом клике на чекбокс устанавливаем sessionStorage.setItem 
		},
		checkTableRows(rows) {
			
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
					
				});
				// console.log('rows',rows);
				
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		delSelectedObject(index, objid){
			
			// console.log('delObject id',objid);
			// console.log('delObject index',index);
			for(let i=0; i < this.masSend.length; i++){
				if(this.masSend[i].id == objid){

					//this.$refs.multipleTable.toggleRowStatus(this.masSend,this.masSend[i],false);
					//toggleRowSelection -- эта штука должна бы удалять не только галочку из таблицы, но и объект из выборки на отправку. 
					//Однако при f5 перестает работать до тех пор, пока ты руками не потрогаешь что-то в таблице (кликнуть другой чек-бокс, например). 
					//поэтому удаляю выборку и гадлчку отдельно. Бекбокс синимаю ниже прямо в this.$refs.multipleTable.selection
					
					this.masSend.splice(i, 1);
					
				}  
			}
			if (this.$refs.multipleTable.selection) { 
				//console.log('hell yeah',this.$refs.multipleTable.selection[index]);
				//Этот index из this.masSend, но this.masSend должен совпадать с массивом таблицы selection, поэтому удаляю по нему
				this.$refs.multipleTable.selection.splice(index, 1);
			}
			
			for(let j=0; j < this.objects.length; j++){
				if(this.objects[j].id == objid){
					//console.log('this.objects[j].id',this.objects[j].id);
					//удаляем из пропса, если это был ранее переданный и сохраненный объект, но который теперь КЦ не нужен.
					this.objects.splice(j, 1);
				} 
			}
			// for(let k=0; k < this.cashedTableSelection.length; k++){
			// 	if(this.cashedTableSelection[k].id == objid){
			// 		console.log('this.cashedTableSelection[j].id',this.cashedTableSelection[k].id);
			// 		// console.log('this.masSend[i]',this.masSend[i]);

			// 		// this.$refs.multipleTable.toggleRowSelection(this.cashedTableSelection[k], false); // эта штука удалит не только галочку из таблицы, но и объект из выборки на отправку
			// 		this.cashedTableSelection.splice(k, 1);
			// 	} 
			// }
			this.cashedTableSelection = [];
			this.sessionStorageData = '';
			this.saveLocalSettings();
			
			this.finalBossSend = this.objects; //
			
			
			// console.log('this.masSend after checkTableRows',this.masSend);
			

			// после удаления из выборки нужно перезаписать объекты в sessionStorage?
			
			// let sessiondata = [];
			// if(this.sessionStorageData!=undefined){
			// 	// sessiondata = JSON.parse(sessionStorage.getItem("lead-search-objects"));
			
			// 	const filtered = sessionStorageData.filter(item => item.id != objid);
			// 	sessionStorage.setItem('lead-search-objects', JSON.stringify(filtered));
			// }	
			
		},
		clearObjects(){
			this.masSend= [];
			this.message2parent('LeadObjects', []);
			this.$refs.multipleTable.clearSelection();
			sessionStorage.removeItem("lead-search-objects");
		},
		
		saveLocalSettings(){
			if(this.masSend!='' && this.masSend!=undefined){
				sessionStorage.setItem(this.storageName,JSON.stringify(this.masSend));
			}
			// console.log('setItem to sessionStorage ',sessionStorage);
		},
		getTableSelectionFromStorage(){
			this.masSend = [];
			this.sessionStorageData = sessionStorage.getItem("lead-search-objects");
			//console.log('getTableSelectionFromStorage', this.sessionStorageData);

			if(this.sessionStorageData!='[]' && this.sessionStorageData!=undefined){
				this.cashedTableSelection = JSON.parse(this.sessionStorageData);
				
				if(this.cashedTableSelection.length > 0){
					// for(let i = 0; i < this.cashedTableSelection.length; i++){
					// 	this.masSend.push(this.cashedTableSelection[i]);
					// 	//console.log(this.cashedTableSelection[i]);
					// }
					// this.checkTableRows(this.cashedTableSelection);
					// this.$refs.multipleTable.toggleRowSelection(this.cashedTableSelection, true);
					this.masSend = this.cashedTableSelection;
				}
			}
			this.$refs.multipleTable.doLayout();
		}
	},		
	mounted(){
		//console.log('mounted');
		// this.$nextTick(function () {
		// 	// console.log('this.masTableSelection', this.masTableSelection);
		// 	// this.handleSelectionChange(this.objects); 

		
		// 	if(this.cashedTableSelection.length > 0){
				
		// 		this.checkTableRows(this.masTableSelection);
		// 	}
		// });
		this.getTableSelectionFromStorage();
		
		if(this.cashedTableSelection.length > 0){
			this.checkTableRows(this.masSend);
		}

		
		
	}
};
</script>
<style scoped>

/* .ReLeadTable {border: 1px solid #01b0e0; padding: 20px 5px 0px 15px; border-radius: 6px;} */
/* .card-wrapper {width: 100%; }
.card-wrapper-center {
    justify-content: center;
    margin: 0 auto;
    display: flex;
	max-width: 3000px;
} */
.ReLeadTable >>> .el-table tr:hover {cursor: pointer; background: rgb(1, 176, 224, 0.33);}
/* .ReLeadTable >>>  .el-table table {width: 100%!important;} */
.ReLeadTable >>>  .el-table .cell {word-break: break-word; }
.ReLeadTable >>> .white-content .card:not(.card-white) .el-table .cell {color: #222a42!important;}

.ReLeadTable {position: relative;}
.btn-sticky {
	position: sticky;
    top: 0px;
    z-index: 2;
	background-color: #27293d;
	display: flex;
    justify-content: center;
	border-bottom: 1px solid #01B0E0;
}

.white-content .card:not(.card-white) .btn-sticky {
	background: #fff;
}

.white-content .card:not(.card-white) >>> .table td, 	.white-content .card:not(.card-white) >>> .el-table td,
.white-content .card:not(.card-white) >>> .table th, 	.white-content .card:not(.card-white) >>> .el-table th {
    color: #222a42!important;
}

</style>
